import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { UserAccessRegulatorService } from "../services/user-access-regulator.service";
import { b2bRedirectPath } from "./b2b-redirect-path";

export const authChainalysisGuard = () => {
  const userAccessRegulator = inject(UserAccessRegulatorService);
  const router = inject(Router);
  return userAccessRegulator.hasAccessToClientB2B || userAccessRegulator.hasAccessToAdmin
    ? router.parseUrl(b2bRedirectPath(userAccessRegulator).join("/"))
    : true;
};
